import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';

import { isEmpty, startCase } from 'lodash';
import clsx from 'clsx';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';

import BobWorkbookModeButton from '../../../components/BobWorkbookModeButton';
import AssignmentTable from './AssignmentTable';

import * as AttributeManagementActions from '../../../actions/attributeManagementActions';
import * as DashboardActions from '../../../actions/dashboardActions';

import * as classes from './AssignmentInsert.module.css';

const MenuProps = {
    disablePortal:      true,
    getContentAnchorEl: () => null,
    PaperProps:         {
        style: {
            maxHeight: 500
        },
    },
};

const AssignmentInsert = ({
    activeNavCompany,
    attributeValue,
    fetchAMClients,
    entities,
    selectedAttribute,
    selectedEntity,
    items,
    setAMSelectedAttributeValue,
    setItems,
    setWorkBookMode,
    workbookModeEnabled,
    ...props
}) => {
    const [data, setData] = useState([]);
    const [columns, setColumns] = useState([]);
    const [availableValues, setAvailableValues] = useState([]);

    useEffect(() => {
        const init = async () => {
            if (selectedEntity.name === 'Client') {
                const clients = await fetchAMClients(activeNavCompany.id);
                const attributeName = startCase(selectedAttribute.name);

                clients.forEach(item => {
                    if (!isEmpty(item.customAttributes)) {
                        const index = item.customAttributes.findIndex(item => item.customAvp.attributeId === selectedAttribute.id);

                        if (index >= 0) {
                            const attributeValue = item.customAttributes[index].customAvp.attributeValue;
                            item.attributeValue = attributeValue;
                        }
                    }
                });
                setColumns(
                    [
                        {
                            title:       'Name',
                            field:       'name',
                            width:       300,
                            show:        true,
                            filter:      'text',
                            sortable:    true,
                            filterable:  workbookModeEnabled,
                            locked:      false,
                            reorderable: true
                        },
                        {
                            title:       attributeName,
                            field:       'attributeValue',
                            width:       200,
                            show:        true,
                            filter:      'text',
                            sortable:    true,
                            filterable:  workbookModeEnabled,
                            locked:      false,
                            reorderable: true,
                            isAttribute: true
                        }
                    ]
                );

                setData(clients);
            }
        };

        if (!isEmpty(selectedEntity) && selectedEntity.id) init();
    }, [selectedEntity]);

    useEffect(() => {
        if (!isEmpty(entities)) {
            const values = [...entities];
            values.forEach(item => {
                if (!isEmpty(item.customAttributes)) {
                    const attributeValue = item.customAttributes[0].customAvp.attributeValue;
                    item.attributeValue = attributeValue;
                }
            });

            setData(values);
        }
    }, [entities]);

    useEffect(() => {
        if (!isEmpty(items)) {
            const filteredItems = items.filter(item => item.id !== 'select' && item.available !== true);
            setAvailableValues(filteredItems);
        }
    }, [items]);

    const handleWorkbookMode = () => {
        setWorkBookMode(!workbookModeEnabled);
    };

    const handleAttributeValueChange = e => {
        setAMSelectedAttributeValue(e.target.value);
    };

    return (
        <div className={classes.AssignmentInsert}>
            {
                isEmpty(selectedAttribute) || isEmpty(selectedEntity) ?
                    <div className={classes.ErrorContainer}>
                        <span className={clsx('material-icons-outlined md-18', classes.ErrorIcon)}>
                            error_outline
                        </span>
                        <span className={classes.ErrorText}>Please select an Attribute and Entity to proceed.</span>
                    </div>
                    :
                    <div>
                        <div className={classes.TableHeader}>
                            <FormControl variant="outlined" size="small" className={classes.SelectContainer}>
                                <InputLabel id="status">
                                    Value to be applied
                                </InputLabel>
                                <Select
                                    labelId="value"
                                    id="value"
                                    name="value"
                                    onChange={handleAttributeValueChange}
                                    className={classes.select}
                                    MenuProps={MenuProps}
                                    value={attributeValue}
                                >
                                    {
                                        availableValues.map(item => {
                                            return (
                                                <MenuItem className={classes.MenuItem} value={item}>
                                                    {item.name}
                                                </MenuItem>
                                            );
                                        })
                                    }
                                </Select>
                            </FormControl>
                            <BobWorkbookModeButton
                                handleWorkbookMode={handleWorkbookMode}
                                workbookMode={workbookModeEnabled}
                            />
                        </div>
                        <AssignmentTable data={data} columns={columns} selectedEntity={selectedEntity} />
                    </div>
            }
        </div>
    );
};

const mapStateToProps = state => {
    return {
        activeNavCompany:    state.bob.activeNavCompany,
        attributeValue:      state.attributeManagement.selectedAttributeValue,
        entities:            state.attributeManagement.entities,
        workbookModeEnabled: state.dashboard.workbookModeEnabled
    };
};

const mapDispatchToProps = ({
    ...AttributeManagementActions,
    ...DashboardActions
});

export default connect(mapStateToProps, mapDispatchToProps)(AssignmentInsert);
